"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const util_rx_1 = require("./util_rx");
function firestoreSyncDocument(docRef) {
    return new rxjs_1.Observable((subs) => 
    // `onSnapshot` already returns a function that ends the subscription
    docRef.onSnapshot(snap => snap.exists ?
        subs.next(snap) :
        subs.error(`firestoreSyncDocument error, doesn't exist ${docRef.path}`), (error) => subs.error(error), () => subs.complete()));
}
exports.firestoreSyncDocument = firestoreSyncDocument;
function firestoreSyncCollectionArray(ref) {
    return new rxjs_1.Observable((subs) => 
    // `onSnapshot` already returns a function that ends the subscription
    ref.onSnapshot({ includeMetadataChanges: false }, (querySnap) => {
        subs.next(querySnap.docs);
    }, (error) => subs.error(error), () => subs.complete()));
}
exports.firestoreSyncCollectionArray = firestoreSyncCollectionArray;
function firestoreDeleteCollection(collectionRef) {
    return util_rx_1.promise$(() => collectionRef.get())
        .pipe(operators_1.mergeMap((querySnap) => rxjs_1.from(rxjs_1.forkJoin(querySnap.docs.map(doc => rxjs_1.from(doc.ref.delete()))))));
}
exports.firestoreDeleteCollection = firestoreDeleteCollection;
